import { WidgetErrorModel } from '../models/widget-error.model';

// default config
export const defaultContentErrorConfig: WidgetErrorModel = {
  title: `We're unable to find the model you're looking for.`,
  description: `Please check your URL or visit the <a href="/" target="_blank">BioDigital Human</a> to see what's available in our 3D model library.`
};
